import {Model} from "./Model";

export class ExtraVideo extends Model {
    course_id;
    slug;
    name;
    position;
    image;
    questions;
    completed;
    duration;
    video_id;
}